import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { BUTTON } from '@app/modules/shares/enum/rule.enum'
import { PermissionService } from 'projects/vss-ui/src/public-api'

@Component({
  template: ''
})
export class DefaultRedirectComponent {
  constructor(
    private router: Router,
    private _permissionService: PermissionService,
  ) {
    // TODO: Có thể lấy quyền, resolve data ở đây nếu cần
    if (!this._permissionService.userRules.includes(BUTTON.DASHBOARD)) {
      const menu = this._permissionService.menuObs.getValue();
      const firstChildUrl = this.findFirstChildUrl(menu);
      if (firstChildUrl) {
        this.router.navigate([firstChildUrl]);
      }
      return;
    }
    this.router.navigate(['/dashboard']);

  }

  /**
   * Đệ quy tìm url của menu con gần nhất
   */
  private findFirstChildUrl(menuList: any[]): string | null {
    if (!Array.isArray(menuList)) return null;
    for (const item of menuList) {
      if (item.url) return item.url;
      if (item.children && item.children.length) {
        const childUrl = this.findFirstChildUrl(item.children);
        if (childUrl) return childUrl;
      }
    }
    return null;
  }
}
